
export const SourceInactiveState = () => {
    return <span className="badge badge-secondary">Neaktivní</span>
}